import * as ATC from "../../assets/lib/ATClient/ATClient.js";
import * as ATCCmd from "../../assets/js/myATCCommand.js";
import * as ATCws from "../../assets/lib/ATClient/ATClient.ws.js";
import * as ATCBox from "../../assets/lib/ATClient/ATCInfoBox/ATCInfoBox.js";
// import * as myATCTran from "../../assets/js/myATCTran";
import "../../assets/lib/ATClient/ATCInfoBox/ATCInfoBox.css";
import util from "../../assets/js/util";
import multiWindow from "../../assets/js/multi-window";
import bootbox from "../../assets/lib/bootbox/bootbox";

var isConnect_CTI = 0;
var nTimer_id;
var login_uid;
var login_uid_name;
var login_pwd;
var login_ext;
var _lastSignal = {};

function Connect_CTI() {
    var strCTI_addr = ATC.ATGetCTIInfo("IPADDR_EX", "", 0);
    strCTI_addr = 'ygdjonline.com/ywxtwss/111'
    var strRet = ATCws.ATConnect(strCTI_addr);
    setTimeout(() => {
        Connect_CTI_result();
    }, 1000); // 异步函数,延时100s,再取结果
}

function Connect_CTI_result() {
    var strRet = ATCws.ATCommandResult();
    if (strRet == "OK") {
        rem(".connATC", "ATC已连接");
        var callThinkAdmin = top.base.userInfo.callThinkAdmin;
        client_login(
            callThinkAdmin.loginUid,
            callThinkAdmin.loginPwd,
            callThinkAdmin.loginExt
        );
    } else {
        util.error(
            "与UltraCTI连接失败，请检查，原因：\n  1.网络连接是否正常.\n  2.UltraCTI工作是否正常."
        );
    }
}

// 座席登录
function client_login(_uid, _pwd, _ext) {
    var validity = false; // assume valid

    if (_pwd == "") _pwd = "";

    if (!check_empty(_uid)) {
        util.info("对不起，您输入的工号不正确！");
        return validity;
    }
    if (!check_empty(_ext)) {
        util.info("对不起，您输入的座席号码不正确！");
        return validity;
    }

    login_uid = _uid;
    login_pwd = _pwd;
    login_ext = _ext;
    ATCBox.setLoginExt(login_ext);
    ATCBox.setLoginUid(login_uid);

    var strLoginGroup = "0"; // 0表示不区分组号
    var strLoginInfo = "COMPRESS=0;REG_GROUP=ALL;NOT_READY=0;";
    // var strLoginInfo = "PROTOCOL=1;COMPRESS=0;REG_GROUP=0;NOT_READY=0;";
    // COMPRESS=0，1-采用压缩传输数据，0-不压缩。
    // REG_GROUP=ALL，0，G1|G2|G3； 注册ACD组的消息，包括：座席、分机、中继、队列等。
    // G1|G2|G3-表示监控指定组。
    // ALL-监控所有消息
    // 0或空-和本座席相关的消息
    // NOT_READY=1，1-登入后不能接听电话，需要签入ATSetReady(uid,1),签出ATSetReady(uid,0)
    // 0-登入后可以接听电话，不要要签入ATSetReady()

    var strRet = ATCws.ATLogin_ex(
        login_uid,
        login_pwd,
        login_ext,
        strLoginGroup,
        strLoginInfo
    );
    setTimeout(() => {
        client_login_result();
    }, 2000); // 异步函数,延时100s,再取结果
    nRetry_times = 0;
}

var nRetry_times = 0;
function client_login_result() {
    var validity = false; // assume valid
    var strRet = ATCws.ATCommandResult();

    if (strRet == "") {
        nRetry_times += 1;
        if (nRetry_times < 20) {
            setTimeout(() => {
                client_login_result();
            }, 100);
            return false;
        }
    }
    if (strRet == "OK") {
        validity = true;
        isConnect_CTI = 1;
        rem(".connATC", "分机" + login_ext);
        $(".connATC").off("click"); //登陆成功后清除登录事件
        $(".ATCDro").on("mouseover", () => {
            $(".ATCMenu").show();
        });
        $(".ATCDro").on("mouseout", () => {
            $(".ATCMenu").hide();
        });
        $(".ATCOut").on("click", () => {
            client_logout(login_uid);
        });
        
        nTimer_id = setTimeout(() => {
            delay_1ms_timer();
        }, 1000);

        //---------------查询坐席列表
        var storeId = top.base.userInfo.store.storeId
        var url = SERVER + '/callThinkAdmin/selectATCExt?storeId='+storeId;
        $.get(url,(data)=>{
            if(data.status==0){
                ATCBox.setExtList(data.data); 


                


        //------------- test -------
        // var callInfo = {
        //     callId: (new Date()).getTime(),
        //     phone: '17303710150',
        //     callType: 1,
        //     uidName: login_uid_name||'',
        //     ext: login_ext,
        //     uid: login_uid,
        // };
        // var boxId1 = ATCBox.ring(callInfo, (boxId) => {//clickInfo
        //     var boxInfo = ATCBox.getBoxInfo(boxId);
        //     var phone = (boxInfo&&boxInfo.phone)||'';
        //     if (phone.length != 3) {
        //         openCallWindow(phone, boxId);
        //     }
        // }, (boxId)=>{//pickupBtn
        //     ATCCmd.AT_Command(login_uid,login_ext,"Pickup");
        //     return true;
        // }, (boxId)=>{//hangupBtn
        //     ATCCmd.AT_Command(login_uid,login_ext,"Hangup");
        //     // 检查业务类型
        //     var boxInfo = ATCBox.getBoxInfo(boxId);
        //     var logId = boxInfo.logId
        //     var phone = (boxInfo&&boxInfo.phone)||'';
        //     var colseFlag = true;
        //     if (phone.length != 3) {
        //         colseFlag = checkCallType(logId);
        //         if(colseFlag){
        //             var winIdx = top.base.getIFrameIndex(boxInfo.winHref);
        //             top.base.closeByIndex(winIdx)
        //         }else{
        //             openCallWindow(phone, boxId);
        //         }
        //     }
        //     return colseFlag;
            
        // }, (boxId)=>{//tranBtn
        //     return true;
        // });
        // insertCallLog(boxId1);
        // if (callInfo.phone.length != 3) {
        //     openCallWindow(callInfo.phone, boxId1);
        // }else{
        //     var extInterval = setInterval(() => {//检测转接成功后弹出用户信息
        //         var boxInfo = ATCBox.getBoxInfo(boxId1);
        //         var myCallInfo = ATC.ATGetCallInfo(boxInfo.uid, boxInfo.ext, "", "");
        //         var caller_code = myCallInfo.m_caller.replace(/^0+/, ""); //清除手机号前缀
        //         var called_code = myCallInfo.m_called.replace(/^0+/, ""); //清除手机号前缀
        //         var mDirection = myCallInfo.m_direction; //1外线呼入2外线呼出3内线呼入4内线呼出
        //         var phoneSec = "";
        //         if (mDirection == "1" || mDirection == "3") {
        //             phoneSec = caller_code;
        //         } else if (mDirection == "2" || mDirection == "4") {
        //             phoneSec = called_code;
        //         }
        //         var callInfo = {
        //             callId: myCallInfo.m_callid,
        //             phone: phoneSec,
        //             callType: mDirection,
        //         };
        //         if(phoneSec&&phoneSec.length!=3){
        //             console.log("extInterval=========>",extInterval);
        //             clearInterval(extInterval);
        //             ATCBox.setBoxInfo(callInfo, boxId1);
        //             openCallWindow(callInfo.phone, boxId1);
        //         }
        //     }, 1000);
        // }
        // get_ext_status("", "03", callInfo);
   
        // setTimeout(()=>{
        //     var callInfo = {
        //         callId: (new Date()).getTime(),
        //         phone: '630',
        //         callType: 3,
        //         uidName: login_uid_name||'',
        //         ext: login_ext,
        //         uid: login_uid,
        //     };
        //     var boxId2 = ATCBox.ring(callInfo, (boxId) => {//clickInfo
        //         var boxInfo = ATCBox.getBoxInfo(boxId);
        //         var phone = (boxInfo&&boxInfo.phone)||'';
        //         if (phone.length != 3) {
        //             openCallWindow(phone, boxId);
        //         }
        //     }, (boxId)=>{//pickupBtn
        //         ATCCmd.AT_Command(login_uid,login_ext,"Pickup");
        //         return true;
        //     }, (boxId)=>{//hangupBtn
        //         ATCCmd.AT_Command(login_uid,login_ext,"Hangup");
        //         // 检查业务类型
        //         var boxInfo = ATCBox.getBoxInfo(boxId);
        //         var logId = boxInfo.logId
        //         var phone = (boxInfo&&boxInfo.phone)||'';
        //         var colseFlag = true;
        //         if (phone.length != 3) {
        //             colseFlag = checkCallType(logId);
        //             if(colseFlag){
        //                 var winIdx = top.base.getIFrameIndex(boxInfo.winHref);
        //                 top.base.closeByIndex(winIdx)
        //             }else{
        //                 openCallWindow(phone, boxId);
        //             }
        //         }
        //         return colseFlag;
        //     }, (boxId)=>{//tranBtn
        //         return true;
        //     });
        //     insertCallLog(boxId2);
        //     if (callInfo.phone.length != 3) {
        //         openCallWindow(callInfo.phone, boxId2);
        //     }else{
        //         var extInterval = setInterval(() => {//检测转接成功后弹出用户信息
        //             var boxInfo = ATCBox.getBoxInfo(boxId2);
        //             var myCallInfo = ATC.ATGetCallInfo(boxInfo.uid, boxInfo.ext, "", "");
        //             var caller_code = myCallInfo.m_caller.replace(/^0+/, ""); //清除手机号前缀
        //             var called_code = myCallInfo.m_called.replace(/^0+/, ""); //清除手机号前缀
        //             var mDirection = myCallInfo.m_direction; //1外线呼入2外线呼出3内线呼入4内线呼出
        //             var phoneSec = "";
        //             if (mDirection == "1" || mDirection == "3") {
        //                 phoneSec = caller_code;
        //             } else if (mDirection == "2" || mDirection == "4") {
        //                 phoneSec = called_code;
        //             }
        //             phoneSec = '15966672863';
        //             var callInfo = {
        //                 callId: myCallInfo.m_callid,
        //                 phone: phoneSec,
        //                 callType: mDirection,
        //             };
        //             if(phoneSec&&phoneSec.length!=3){
        //                 console.log("extInterval=========>",extInterval);
        //                 clearInterval(extInterval);
        //                 ATCBox.setBoxInfo(callInfo, boxId2);
        //                 openCallWindow(callInfo.phone, boxId2);
        //             }
        //         }, 1000);
        //     }
        // },1000)


        //------------- end ------


        
            }else{
                util.error(data.message);
            }
        });
        //-------------------

        return validity;
    } else if (strRet == "ERROR_UID")
        util.info("登录失败，请检查工号是否正确！");
    else if (strRet == "ERROR_PWD")
        util.info("登录失败，请检查密码是否正确！");
    else if (strRet == "ERROR_REP") 
        util.info("对不起，该帐号正在使用！");
    else if (strRet == "FAIL")
        util.info("登录失败，请检查工号或密码是否正确！");
    else
        util.info(
            "登录失败，请检查网络或呼叫中心是否运行正常！"
        );

    $(".connATC")
        .off("click")
        .click(() => {
            //登录失败后设置手动登录事件
            client_login_ext();
        });

    return validity;
}

function client_login_ext() {
    //手动登录
    var bootboxHtml =
        '分机号：<input type="text" class="form-control input-sm" name="l_ext" id="l_ext" placeholder="请输入分机号">';
    var ATCLoginDialog = bootbox.dialog({
        title: "登录ATC",
        message: bootboxHtml,
        buttons: {
            waive: {
                label: "取消",
                className: "btn-default",
                callback: (e) => {},
            },
            next: {
                label: "登录",
                className: "btn-primary",
                callback: (e) => {
                    var l_ext = $("#l_ext").val();
                    if (!l_ext) {
                        util.error("请输入分机号！");
                        return false;
                    }
                    client_login(login_uid, login_pwd, l_ext);
                },
            },
        },
        show: false,
        size: "small",
    });
    ATCLoginDialog.modal("show");
}

function client_logout(login_uid) {
    // 座席登出
    var validity = true;
    if (isConnect_CTI > 0) {
        var Result = ATCws.ATLogout_ex(login_uid);
        isConnect_CTI = 0;
        rem(".connATC", "点击登录ATC");
        util.success("ATC已退出！");
        login_ext = "";
        login_uid = "";
        ATCBox.setLoginUid("");
        ATCBox.setLoginExt("");
        $(".ATCDro").off("mouseover mouseout");
        $(".ATCOut").off("click");
        $(".dropdown-menu.ATCMenu").hide();
        $(".connATC")
            .off("click")
            .click(() => {
                client_login_ext();
            });
    }
    return validity;
}

function check_empty(text) {
    return text.length > 0; // 如果为空则返回错误
}

function delay_1ms_timer() {
    if (isConnect_CTI == -1) {
        client_login(login_uid, login_pwd, login_ext);
        return 1; // 只提示一次
    }
    nTimer_id = setTimeout(() => {
        delay_1ms_timer();
    }, 1000);
    return 1;
}

function onReceivePopupInfo(EventCode, EventData, EventInfo) {
    if (EventCode == "4" && $("#myTranContent").is(":visible")) {
        ATCBox.changeTranExtStatus(EventCode, EventData, EventInfo);
        // return;
    }

    // --------------- 信号去重 start --------------
    var Signal = EventCode + "_" + EventData + "_" + EventInfo;
    if(Signal == _lastSignal[EventCode]){
        return;
    }
    _lastSignal[EventCode] = EventCode + "_" + EventData + "_" + EventInfo;
    // -------------- 信号去重 end -----------------

    if (EventData == login_uid || EventData == login_ext || EventCode == 100) {
        console.log("EventCode, EventData, EventInfo ====>", EventCode, EventData, EventInfo)
        //过滤非本分机，本坐席的事件
        myATClient_onReceiveCTI_EventChanged(EventCode, EventData, EventInfo);
    }
}

// 接收ATClient的消息
function myATClient_onReceiveCTI_EventChanged(EventCode, EventData, EventInfo) {
    switch (
        EventCode //注释掉的方法，暂时不需要处理
    ) {
        case 0: // 显示信息
            break;
        case 1: // 1：表示座席员状态发生变化，EventData 表示座席员工号
            //坐席状态
            var uidInfo = ATC.ATGetUidInfo(EventData);
            show_agent_status_uid(EventData, EventInfo, uidInfo);
            break;
        case 2: // 表示坐席呼叫状态发生变化，EventData 表示座席员工号
            break;
        case 3: // 3：表示外线状态发生变化，EventData 表示外线号码
            break;
        case 4: // 4：表示分机状态发生变化，EventData 表示分机号
            var myCallInfo = ATC.ATGetCallInfo(login_uid, login_ext, "", "");
            var caller_code = myCallInfo.m_caller.replace(/^0+/, ""); //清除手机号前缀
            var called_code = myCallInfo.m_called.replace(/^0+/, ""); //清除手机号前缀
            var mDirection = myCallInfo.m_direction; //1外线呼入2外线呼出3内线呼入4内线呼出
            var phone = "";
            if (mDirection == "1" || mDirection == "3") {
                phone = caller_code;
            } else if (mDirection == "2" || mDirection == "4") {
                phone = called_code;
            }
            var callInfo = {
                callId: myCallInfo.m_callid,
                phone: phone,
                callType: mDirection,
                uid:login_uid,
                ext:login_ext,
                uidName: login_uid_name||'',
            };
            get_ext_status(EventData, EventInfo, callInfo);
            break;
        case 5: // 5：表示其它座席传来消息，EventData 表示消息内容
            break;
        case 6: // 6：表示有用户呼入信息：应用程序依靠此消息弹出用户资料，EventData 表示分机号
            break;
        case 7: // 7：表示有OEM呼入信息，可能是FAX、VMS、EMAIL、SMS、CHAT等
            break;
        case 10: // 10：表示呼叫进入排队，EventData 表示呼叫标识
            break;
        case 11: // 11：表示呼叫结束排队，EventData 表示呼叫标识
            break;
        case 100: // 100：表示与服务器的连接中断
            var strDisp =
                "本座席与呼叫中心的连接中断，请重新登录！";
            if (isConnect_CTI > 0) {
                isConnect_CTI = -1;
                $(".ATCDro .status").html("[连接已断开]");
                util.info(strDisp);
            }
            break;
    }
}

function show_agent_status_uid(strUid, EventInfo, uidInfo) {
    //坐席状态
    var user_uid = uidInfo.m_uid;
    var user_ext = uidInfo.m_ext;
    var user_name = uidInfo.m_name || user_uid || user_ext;
    var UidStatus = uidInfo.m_status || EventInfo;
    login_uid_name = user_name;

    if (UidStatus == "01") UidStatus = "空闲";
    //可工作
    else if (UidStatus == "02") UidStatus = "忙碌";
    else if (UidStatus == "03") UidStatus = "事后处理";
    else if (UidStatus == "04") UidStatus = "离席";
    else if (UidStatus == "05")
        //选中状态，不做处理
        return false;
    else if (UidStatus == "06") UidStatus = "未准备好";
    else if (UidStatus == "00") UidStatus = "注销";

    $(".ATCDro .status").html("(" + user_name + ")" + "[" + UidStatus + "]");
}

function get_ext_status(strExt, strStatus, callInfo) {
	var phone = callInfo.phone;
    var lbl_name;
    switch (strStatus) {
        case "01": // 空闲
            lbl_name = "空闲";
            break;
        case "02": // 应答
            lbl_name = "摘机";
            break;
        case "03": // 振铃
            lbl_name = "振铃";
            //-------- 吊起来电小窗 ---------
            var boxId = ATCBox.ring(callInfo, (boxId) => {//clickInfo
                var boxInfo = ATCBox.getBoxInfo(boxId);
                var phone = (boxInfo&&boxInfo.phone)||'';
                if (phone.length != 3) {
                    openCallWindow(phone, boxId);
                }
            }, (boxId)=>{//pickupBtn
                ATCCmd.AT_Command(login_uid,login_ext,"Pickup");
                return true;
            }, (boxId)=>{//hangupBtn
                ATCCmd.AT_Command(login_uid,login_ext,"Hangup");
                // 检查业务类型
                var boxInfo = ATCBox.getBoxInfo(boxId);
                var logId = boxInfo.logId
                var phone = (boxInfo&&boxInfo.phone)||'';
                var colseFlag = true;
                if (phone.length != 3) {
                    colseFlag = checkCallType(logId);
                    if(colseFlag){
                        var winIdx = top.base.getIFrameIndex(boxInfo.winHref);
                        top.base.closeByIndex(winIdx)
                    }else{
                        openCallWindow(phone, boxId); 
                    }
                }
                return colseFlag;
            }, (boxId)=>{//tranBtn
                return true;
            });
            insertCallLog(boxId);
            if (phone.length != 3) {
                openCallWindow(phone, boxId);
            }else{
                var extInterval = setInterval(() => {//检测转接成功后弹出用户信息
                    var boxInfo = ATCBox.getBoxInfo(boxId);
                    var myCallInfo = ATC.ATGetCallInfo(boxInfo.uid, boxInfo.ext, "", "");
                    var caller_code = myCallInfo.m_caller.replace(/^0+/, ""); //清除手机号前缀
                    var called_code = myCallInfo.m_called.replace(/^0+/, ""); //清除手机号前缀
                    var mDirection = myCallInfo.m_direction; //1外线呼入2外线呼出3内线呼入4内线呼出
                    var phoneSec = "";
                    if (mDirection == "1" || mDirection == "3") {
                        phoneSec = caller_code;
                    } else if (mDirection == "2" || mDirection == "4") {
                        phoneSec = called_code;
                    }
                    var callInfo = {
                        callId: myCallInfo.m_callid,
                        phone: phoneSec,
                        callType: mDirection,
                    };
                    if(phoneSec&&phoneSec.length!=3){
                        console.log("extInterval=========>",extInterval);
                        clearInterval(extInterval);
                        ATCBox.setBoxInfo(callInfo, boxId);
                        openCallWindow(phone, boxId);
                    }
                }, 1000);
            }
            bindRequirement(callInfo);
            //-------- end -------
            break;
        case "04": // 回铃
            lbl_name = "回铃";
            //-------- 吊起来电小窗 ---------
            // var boxId = ATCBox.ring(callInfo, (boxId) => {//clickInfo
            //     var boxInfo = ATCBox.getBoxInfo(boxId);
            //     var phone = (boxInfo&&boxInfo.phone)||'';
            //     if (phone.length != 3) {
            //         openCallWindow(phone, boxId);
            //     }
            // }, (boxId)=>{//pickupBtn
            //     ATCCmd.AT_Command(login_uid,login_ext,"Pickup");
            //     return true;
            // }, (boxId)=>{//hangupBtn
            //     ATCCmd.AT_Command(login_uid,login_ext,"Hangup");
            //     // 检查业务类型
            //     var boxInfo = ATCBox.getBoxInfo(boxId);
            //     var logId = boxInfo.logId
            //     var colseFlag = true;
            //     if (phone.length != 3) {
            //         colseFlag = checkCallType(logId);
            //         if(colseFlag){
            //             var winIdx = top.base.getIFrameIndex(boxInfo.winHref);
            //             top.base.closeByIndex(winIdx)
            //         }else{
            //             openCallWindow(phone, boxId);
            //         }
            //     }
            //     return colseFlag;
            // }, (boxId)=>{//tranBtn
            //     return true;
            // });
            // insertCallLog(boxId);
            // ATCBox.pickup(boxId);
            // if (phone.length != 3) {
            //     openCallWindow(phone, boxId);
            // }else{
            //     var extInterval = setInterval(() => {//检测转接成功后弹出用户信息
            //         var boxInfo = ATCBox.getBoxInfo(boxId);
            //         var myCallInfo = ATC.ATGetCallInfo(boxInfo.uid, boxInfo.ext, "", "");
            //         var caller_code = myCallInfo.m_caller.replace(/^0+/, ""); //清除手机号前缀
            //         var called_code = myCallInfo.m_called.replace(/^0+/, ""); //清除手机号前缀
            //         var mDirection = myCallInfo.m_direction; //1外线呼入2外线呼出3内线呼入4内线呼出
            //         var phoneSec = "";
            //         if (mDirection == "1" || mDirection == "3") {
            //             phoneSec = caller_code;
            //         } else if (mDirection == "2" || mDirection == "4") {
            //             phoneSec = called_code;
            //         }
            //         var callInfo = {
            //             callId: myCallInfo.m_callid,
            //             phone: phoneSec,
            //             callType: mDirection,
            //         };
            //         if(phoneSec&&phoneSec.length!=3){
            //             console.log("extInterval=========>",extInterval);
            //             clearInterval(extInterval);
            //             ATCBox.setBoxInfo(callInfo, boxId);
            //             openCallWindow(phone, boxId);
            //         }
            //     }, 1000);
            // }
            bindRequirement(callInfo);
            //-------- end -------
            break;
        case "05": // 连接
            lbl_name = "通话";
            break;
        case "06": // 断开
            lbl_name = "断开";
            break;
        case "07": // 摘机
            lbl_name = "占用";
            break;
        case "08": // 转移
            lbl_name = "转移";
            break;
        default:
            // 未知
            lbl_name = "未知";
            break;
    }
    return lbl_name;
}

function bindRequirement(callInfo){
    var phone = callInfo.phone;
    var callId = callInfo.callId;
    var url = SERVER + '/customerRequirement/requirementList?requirementStatus=2&customerPhone='+phone+'&pageNum=1&pageSize=100';
    $.get(url,(res)=>{
        if(res.status==0){
            var data = res.data.list;
            if(data==null||data.size==0){
                return false;
            }
            var ids = [];
            for(let idx in data){
                ids.push(data[idx].requirementId);
            }
            var urll = '/customerRequirement/addProcessBatch';
            var param = {};
            param.requirementIdList = ids;
            param.callId = callId;
            param.sourceType = 1;

            var ext = callInfo.ext;
            var uidName = callInfo.uidName;
            var mDirection = callInfo.callType;
            var sDirection = "";//1外线呼入2外线呼出3内线呼入4内线呼出
            if (mDirection == "1" || mDirection == "3") {
                sDirection = "呼入";
            } else if (mDirection == "2" || mDirection == "4") {
                sDirection = "呼出";
            }
            param.content = "12343电话沟通（"+sDirection+"），用户："+phone+"，坐席："+ext+"（"+uidName+"）";
            $.post(SERVER + urll,JSON.stringify(param),(ress)=>{

            });
        }
    });
}

function openCallWindow(phone, boxId) {
    var href = '/my-ATC-detail.html?phone='+phone+'&boxId='+boxId;
    ATCBox.setBoxInfo({'winHref':href}, boxId);
    top.base.openWindow(phone, href);
}

function checkCallType(logId){
    var url = SERVER + '/callLog/checkType?id=' + logId;
    var resFlag = false;
    $.ajax({
        type: "GET",
        url: url,
        data: '',
        async: false,
        success: function(data){
            if(data.status==0){
                var callLog = data.data;
                if(!(callLog&&callLog.type)){
                    util.error("请选择本次通话【业务类型】！");
                    resFlag = false;
                }else{
                    resFlag = true;
                }
            }else{
                util.error(data.message);
                resFlag = false;
            }
        },
        error: function(q,e){
            util.error('网络异常！');
            resFlag = false;
        }
    });
    return resFlag;
}

function insertCallLog(boxId){
    var boxInfo = ATCBox.getBoxInfo(boxId);
    var callObj = {};
    callObj.callId = boxInfo.callId;
    callObj.callType = boxInfo.callType;
    callObj.customerType = '';
    callObj.personnel = boxInfo.uidName;//坐席姓名
    callObj.atcUid = login_uid;//座席员工号
    callObj.atcExt = login_ext;//分机号
    callObj.callPhone = boxInfo.phone;//用户手机号
    callObj.callName = boxInfo.name;//用户姓名
    var url = SERVER + '/callLog/insertCallLog';
    $.post(url,JSON.stringify(callObj),(data)=>{
        if(data.status==0){
            // util.info("通话记录保存成功！");
            var logId = data.data;
            ATCBox.setBoxInfo({'logId':logId}, boxId);
        }else{
            util.error("通话记录保存失败！");
        }
    });
}

function rem(selector, strMsg) {
    $(selector).html(strMsg);
}

function init() {
    Connect_CTI();
}

export {
    init,
    onReceivePopupInfo,
    login_uid,
    login_ext,
};
